import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,[_c(VCardTitle,{staticClass:"headline darken-1",class:_vm.titleColor},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c(VCardText,[_vm._t("content")],2),_c(VCardActions,[_vm._t("action")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }